export const EMPTY_PROPERTY_STATE_TEXT = '--';